import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
  Divider,
  Table,
  TableBody,
  TableRow,
  TableCell,
  colors
} from '@material-ui/core';

import EditAgent from '../../EditAgent/EditAgent';

const useStyles = makeStyles(theme => ({
    root: {},
    
    content: {
        padding: 0
    },

    actions: {
        flexDirection: 'column',
        alignItems: 'flex-end',
            '& > * + *': {
            marginLeft: 0
        }
    },

    buttonIcon: {
        marginRight: theme.spacing(1)
    },

    editButton: {
        color: theme.palette.white,
        backgroundColor: colors.blue[600],
        '&:hover': {
        backgroundColor: colors.blue[900]
        }
    }
    
}));

// export default function DetailData(props) {

//     const { agents, className, ...rest } = props;

//     const classes = useStyles();
  
//     const [openEdit, setOpenEdit] = useState(false);
  
//     const handleEditOpen = () => {
//       setOpenEdit(true);
//     };
  
//     const handleEditClose = () => {
//       setOpenEdit(false);
//     };

//     return (
//         <Card
//             {...rest}
//             className={clsx(classes.root, className)}
//         >
//             <CardHeader title="Agent Detail" />
//             <Divider />
//             <CardContent className={classes.content}>
//                 <Table>
//                     <TableBody>
//                     <TableRow>
//                         <TableCell>Name</TableCell>
//                         <TableCell>
//                             {agents.name}
//                         </TableCell>
//                     </TableRow>
//                     <TableRow>
//                         <TableCell>Email</TableCell>
//                         <TableCell>{agents.email}</TableCell>
//                     </TableRow>
//                     <TableRow>
//                         <TableCell>Contact Number</TableCell>
//                         <TableCell>{agents.contact}</TableCell>
//                     </TableRow>
                    
//                     </TableBody>
//                 </Table>
//             </CardContent>
//             <CardActions className={classes.actions}>
//                 <Button className={classes.editButton} onClick={handleEditOpen}>
//                     Edit
//                 </Button>
               
//             </CardActions>
//             <EditAgent
//                 agents={agents}
//                 onClose={handleEditClose}
//                 open={openEdit}
//             />
//         </Card>
//     );
// }

export default class DetailData extends React.Component{

    constructor(props){
        super(props);
        console.log('DetailData');
        console.log(props);
        this.state = {
            agents: props.agents,
            agent_id: props.agent_id  
        };
    }

    componentWillReceiveProps(props){
        this.setState({
            agents: props.agents
        });
    }
    
    // const {  className, ...rest } = props;
    // const admins = props.admins;
    // const classes = useStyles();
  
    // const [openEdit, setOpenEdit] = useState(false);
  
    handleEditOpen() {
      //setOpenEdit(true);
    };
  
    handleEditClose(){
      //setOpenEdit(false);
    };

    toPage(agent_id){
        window.location.href = '/agent/detailagent/'+ agent_id;
    };

    render(){
            return (
                // <Card
                //     {...this.props.rest}
                //     className={clsx(this.props.classes.root, this.props.className)}
                // >
                //     <CardHeader title="Admin Detail" />
                //     <Divider />
                //     <CardContent className={this.props.classes.content}>
                //         <Table>
                //             <TableBody>
                //             <TableRow>
                //                 <TableCell>Name</TableCell>
                //                 <TableCell>
                //                     {this.state.admins.name}
                //                 </TableCell>
                //             </TableRow>
                //             <TableRow>
                //                 <TableCell>Email</TableCell>
                //                 <TableCell>{this.state.admins.email}</TableCell>
                //             </TableRow>
                //             <TableRow>
                //                 <TableCell>Contact Number</TableCell>
                //                 <TableCell>{this.state.admins.contact}</TableCell>
                //             </TableRow>
                //             <TableRow>
                //                 <TableCell>Position</TableCell>
                //                 <TableCell>{this.state.admins.position}</TableCell>
                //             </TableRow>
                            
                //             </TableBody>
                //         </Table>
                //     </CardContent>
                //     <CardActions className={this.props.classes.actions}>
                //         <Button className={this.props.classes.editButton} onClick={this.handleEditOpen}>
                //             Edit
                //         </Button>
                    
                //     </CardActions>
                //     <EditAdmin
                //         admins={this.state.admins}
                //         onClose={this.handleEditClose}
                //         open={this.openEdit}
                //     />
                // </Card>
                <Card
                {...this.props.rest}
                className={clsx(this.props.classes.root, this.props.className)}
                >
                <CardHeader title="Agent Detail" />
                <Divider />
                <CardContent className={this.props.classes.content}>
                    <Table>
                        <TableBody>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>
                                {this.state.agents.name}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Email</TableCell>
                            <TableCell>{this.state.agents.email}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Contact Number</TableCell>
                            <TableCell>{this.state.agents.contact}</TableCell>
                        </TableRow>
                        
                        </TableBody>
                    </Table>
                </CardContent>
                <CardActions className={this.props.classes.actions}>
                    {/* <Button className={this.props.classes.editButton} onClick={this.handleEditOpen}>
                        Edit
                    </Button> */}
                    
                </CardActions>
                {/* <EditAgent
                    agent={this.state.agent}
                    onClose={this.handleEditClose}
                    open={this.openEdit}
                /> */}
            </Card>
            );
        }   
}
